import {createTheme, CssBaseline, ThemeProvider} from '@mui/material';
import {useSelector} from 'react-redux';
import {getDesignTokens} from './theme';
import {ReactNode, useEffect, useMemo} from 'react';
import { selectCurrentTheme } from '../selectors/common';

interface ThemeWrapperProps {
  children: ReactNode;
}

const ThemeWrapper: React.FC<ThemeWrapperProps> = ({ children }) => {
  const darkTheme = useSelector(selectCurrentTheme);
  // createTheme is expensive and a new theme object invalidates emotion's style cache for every
  // styled component below, so build it once per mode rather than on every render.
  const theme = useMemo(() => createTheme(getDesignTokens(darkTheme ? 'dark' : 'light') as any), [darkTheme])

  useEffect(() => {
    document.documentElement.style.colorScheme = darkTheme ? 'dark' : 'light'
    document.documentElement.style.backgroundColor = theme.palette.background.default
  }, [darkTheme, theme.palette.background.default])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default ThemeWrapper;